export const CLASS_SELECTABLE = 'o-SearchProductListItem__selectableSection'
